// tokenReducer.js
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ILocations } from 'utils/models/locations';
interface LocationState {
	updateLocation: ILocations[];
	testKits: any[];
}

const initialState: LocationState = {
	updateLocation: [],
	testKits: []
};

const locationSlice = createSlice({
	name: 'updateLocation',
	initialState,
	reducers: {
		setUpdatedLocations: (state, action: PayloadAction<ILocations[]>) => {
			state.updateLocation = action.payload;
		},
		addNewLocation: (state, action: PayloadAction<ILocations>) => {
			state.updateLocation.push(action.payload);
		},
		updateExistingLocation: (state, action: PayloadAction<ILocations>) => {
			const index = state.updateLocation.findIndex(loc => loc.id === action.payload.id);
			if (index !== -1) {
				state.updateLocation[index] = action.payload;
			}
		},
		removeLocation: (state, action: PayloadAction<number>) => {
			const id = action.payload;
			const index = state.updateLocation.findIndex(loc => loc.id === id);
			state.updateLocation.splice(index, 1);
		},
		setTestKitsRedux: (state, action: PayloadAction<any[]>) => {
			state.testKits = action.payload;
		}
	}
});

export const { 
	setUpdatedLocations, 
	addNewLocation, 
	updateExistingLocation, 
	removeLocation,
	setTestKitsRedux
} = locationSlice.actions;

export default locationSlice.reducer;
